'use client'

import { createBrowserClient } from '@supabase/ssr'
import { Database } from '@/types/types_db'
import { getSupabasePublicEnv } from '@/utils/publicEnv'

const { url, anonKey } = getSupabasePublicEnv()

// Define a function to create a Supabase client for client-side operations
// @@TODO: Change to singleton and refactor its callers:
// export const supabase = createBrowserClient<Database>(url, anonKey)
export const createClient = () => createBrowserClient<Database>(url, anonKey)
